import React from "react";
import "./style.scss";
import CVGContent from "./cvgcontent";
import SingleContent from "./singlecontent";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

export default function BalanceSummary() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="balance-wrap">
      <div className="text-right mt-2">
        <AppBar className="tabs-toggle" position="static">
          <Tabs value={value} onChange={handleChange} indicatorColor="primary">
            <Tab label="CVG" {...a11yProps(0)} />
            <Tab label="Single" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
      </div>

      <TabPanel value={value} index={0}>
        <CVGContent />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SingleContent />
      </TabPanel>
    </div>
  );
}
